
import React from "react";
import { Outlet } from "react-router-dom";
const ConfigurationIndex = () => {
    return (
        <div>
            <Outlet />
        </div>
    )
}

export default ConfigurationIndex;